import { ContentPageFeature } from '../ContentPage';

export const HomePageFeature: React.FC<Umbraco.HomePage> = (page) => <ContentPageFeature {...page} />;
